import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { useData } from '../context/DataContext';

// Stripe Payment Links for PRODUCTION
/*const STRIPE_LINKS = {
  100: 'https://buy.stripe.com/aFa00c5Bw7C70xT4P204800',
  200: 'https://buy.stripe.com/test_200...',
  500: 'https://buy.stripe.com/test_500...',
  1000: 'https://buy.stripe.com/test_1000...',
};*/
// Stripe Payment Links for TESTING
const STRIPE_LINKS = {
  100: 'https://buy.stripe.com/test_aFa00c5Bw7C70xT4P204800',
  200: 'https://buy.stripe.com/test_3cI3co1lg9Kf3K5a9m04801',
  500: 'https://buy.stripe.com/test_4gM14gd3Y1dJbcxa9m04802',
  1000: 'https://buy.stripe.com/test_6oU3cofc63lR4O9dly04803',
};
const SuspensionScreen = ({ companyId, isAdmin }) => {
  const { userProfile, retrieveUserProfile } = useData(); // <--- Hook into the fetcher
  const [isRefreshing, setIsRefreshing] = useState(false);

  // --- NEW: AUTO-POLLER ---
  // Every 10 seconds, try to fetch the profile.
  // If the balance is now positive, AppContent will automatically swap the UI.
  useEffect(() => {
    const interval = setInterval(() => {
      console.log('[SuspensionScreen] Auto-checking balance...');
      retrieveUserProfile();
    }, 10000);

    return () => clearInterval(interval);
  }, [retrieveUserProfile]);

  const handleManualRefresh = async () => {
    setIsRefreshing(true);
    await retrieveUserProfile();
    setIsRefreshing(false);
  };

  const getCheckoutUrl = (amount) =>
    `${STRIPE_LINKS[amount]}?client_reference_id=${companyId}___${userProfile.userId}`;

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1c1e29',
        color: 'white',
        padding: '2rem',
      }}
    >
      <FontAwesomeIcon
        icon={faLock}
        size="4x"
        style={{ color: '#ff8a80', marginBottom: '1rem' }}
      />
      <h1
        style={{ color: '#ff8a80', fontSize: '2.5rem', margin: '0 0 1rem 0' }}
      >
        Workspace Suspended
      </h1>
      <p
        style={{
          fontSize: '1.2rem',
          textAlign: 'center',
          maxWidth: '600px',
          margin: '0 0 2rem 0',
          color: '#ccc',
        }}
      >
        Your company's wallet balance has reached the -$50.00 hard limit. Access
        to the Influencersforce platform has been temporarily disabled.
      </p>
      {/* MANUAL REFRESH BUTTON */}
      <button
        onClick={handleManualRefresh}
        style={{
          background: 'none',
          border: '1px solid #555',
          color: '#aaa',
          padding: '8px 15px',
          borderRadius: '20px',
          cursor: 'pointer',
          marginBottom: '20px',
          fontSize: '0.8rem',
        }}
      >
        <FontAwesomeIcon icon={faSyncAlt} spin={isRefreshing} />{' '}
        {isRefreshing ? 'Checking...' : 'I have paid, refresh my balance'}
      </button>
      <div
        style={{
          backgroundColor: '#2c3046',
          padding: '2rem',
          borderRadius: '8px',
          border: '1px solid #444',
          textAlign: 'center',
          width: '100%',
          maxWidth: '500px',
        }}
      >
        {isAdmin ? (
          <>
            <h3 style={{ margin: '0 0 1.5rem 0', color: '#ffcc00' }}>
              Restore Access Instantly
            </h3>
            <p style={{ color: '#a0a0a0', marginBottom: '1.5rem' }}>
              Select a top-up package below. Your workspace will automatically
              unlock immediately after successful payment.
            </p>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '10px',
              }}
            >
              <a
                href={getCheckoutUrl(100)}
                target="_blank"
                rel="noreferrer"
                style={payBtn}
              >
                Add $100
              </a>
              <a
                href={getCheckoutUrl(200)}
                target="_blank"
                rel="noreferrer"
                style={payBtn}
              >
                Add $200
              </a>
              <a
                href={getCheckoutUrl(500)}
                target="_blank"
                rel="noreferrer"
                style={payBtn}
              >
                Add $500
              </a>
              <a
                href={getCheckoutUrl(1000)}
                target="_blank"
                rel="noreferrer"
                style={payBtn}
              >
                Add $1,000
              </a>
            </div>
          </>
        ) : (
          <>
            <h3 style={{ margin: '0 0 1rem 0', color: '#ffcc00' }}>
              Admin Action Required
            </h3>
            <p style={{ color: '#a0a0a0' }}>
              Only users with the 'Admin' role can add funds to the workspace
              wallet. Please contact your administrator to restore access.
            </p>
          </>
        )}
      </div>

      <div
        style={{
          marginTop: '2rem',
          textAlign: 'center',
          color: '#777',
          fontSize: '0.9em',
        }}
      >
        <p>
          Need help? Contact support:{' '}
          <strong>support@influencersforce.com</strong>
        </p>
      </div>
    </div>
  );
};

const payBtn = {
  backgroundColor: '#6f9aee',
  color: 'white',
  padding: '12px',
  borderRadius: '6px',
  textDecoration: 'none',
  fontWeight: 'bold',
  display: 'block',
  transition: 'background 0.2s',
};

export default SuspensionScreen;
